<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <group-filter/>
    </div>
    <div class="aco-details-box">
      <group-list/>
    </div>
  </div>
</template>

<script>
  import GroupFilter from './GroupFilter'
  import GroupList from './GroupList'

  export default {
    components: {
      groupFilter: GroupFilter,
      groupList: GroupList
    }
  }
</script>